import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getPermissionByName, hasReportPermission, isAuthenticated } from './customMethods';
import AccessDenied from './AccessDenied';

/**
 * ProtectedRoute component that checks both authentication and permissions
 * Supports both master-level permissions and report-level permissions
 */
const ProtectedRoute = ({ component: Component, permissionName, reportType, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        // Check if user is authenticated
        if (!isAuthenticated()) {
          return <Redirect to="/login" />;
        }

        // If reportType is specified, check report-level permission
        if (reportType) {
          // Check master reports permission first
          if (!getPermissionByName('reports')) {
            return <AccessDenied message="Your account doesn't have access to reports." />;
          }
          
          // Then check specific report permission
          if (!hasReportPermission(reportType)) {
            return <AccessDenied message="Your account doesn't have access to this report." />;
          }
        }
        // Otherwise check master-level permission
        else if (permissionName) {
          if (!getPermissionByName(permissionName)) {
            return <AccessDenied message="Your account doesn't have access to this page." />;
          }
        }

        // User has permission, render the component
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
